import React, { Component } from "react";

class RulePopover extends Component {
  longDescription = () => {
    if (this.props.Description.length > 200) {
      return "rule-popover-longDescription";
    }
  };

  render() {
    return (
      <div className={"rule-popover-button " + this.props.RulePopoverClassName}>
        {this.props.ruleName}
        <div className="rule-popover-window">
          <div className="rule-popover-rulename">{this.props.verbalName}</div>
          <div className="rule-popover-lecture">{this.props.lecture}</div>
          <div className={"rule-popover-description " + this.longDescription()}>
            {this.props.Description}
          </div>
          <ul className="rule-popover-allPossibleUse">{this.props.HowToUse}</ul>
        </div>
      </div>
    );
  }
}

export default RulePopover;



// WEBPACK FOOTER //
// ./src/components/Modals and Popovers/RulePopover.js